<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import layoutMixin from '@/mixins/layout.mixin'
import gtagMixin from '@/mixins/gtag.mixin'

export default {
  mixins: [layoutMixin, gtagMixin]
}
</script>

<style lang="scss" scoped>
@include mobile {
  /deep/ .navbar-brand {
      margin-right: 0;
  }
  /deep/ .navbar-nav{
    box-shadow: none !important;
    background-color: transparent !important;
    display: flex;
  }
  .navbar {
    padding: 1rem 2rem;
    
    .btn-layout{
     font-size: .875rem !important;
     font-weight: initial;
     padding: .7rem 2.2rem;
     background-color: $blue;
    }
  }

  /deep/ .nav.item button {
    color: $white !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/PublicLayout.vue